// @flow
import React from 'react'
import { connect } from 'react-redux'
import { Title, StyledP, Divider } from 'src/theme/globalStyle'
import RoomDetailForm from 'src/containers/RoomDetailForm'
import ImageGallery from 'src/components/ImageGallery'
import { IconList } from 'src/components/IconList'
import { Expired } from 'src/components/Expired'
import { hasDateExpired } from 'src/helpers/dates'
import { locationsFetchRequest } from '../../ducks/locations'
import type { State } from 'src/types/redux'
import LandingNav from '../NavBar/LandingNav'
import {
  StyledRoomDetail,
  RoomMasthead,
  RoomBody,
  RoomDescription,
  StyledImage,
  ExpiredContainer,
  JoinUsBanner
} from './StyledRoomElements'
type OwnProps = {
  room: any,
  pathname: string,
  roomId: string,
  locationId: string,
  hasExpired: boolean,
  location: any,
  dispatch: any,
  match: {
    params: { locationId: string, roomId: string }
  }
}

class RoomDetail extends React.PureComponent<OwnProps> {
  componentDidMount() {
    this.props.dispatch(locationsFetchRequest())
  }
  render() {
    const { room, pathname, hasExpired, location } = this.props
    const { name, type, icons = [], images = [], basePrice, floorPlan, about, description } = room
    const finalName = location.ref === 'tccw' ? type : name
    const descr =
      location.ref === 'tccw'
        ? description
        : `Our ${`${finalName}`.toLowerCase()} rooms are fully equipped with a comfy queen-size bed, bedding and bed
            linen, desk and desk chair, 24 inch television, ample storage and of course, free wi-fi.
            Cosy, thoughtfully-designed and all yours.`
    return (
      <StyledRoomDetail>
        <RoomMasthead header={images.length > 0 ? images[0] : ''}>
          <LandingNav />
          <JoinUsBanner />
        </RoomMasthead>
        {images.length > 1 && (
          <ImageGallery images={images.map(i => ({ src: i })).slice(1, images.length)} />
        )}
        <RoomBody>
          <RoomDetailForm
            pathname={pathname}
            room={room}
            location={location}
            isAlignedAtStart={images.length > 1}
          />
          <RoomDescription>
            <Title large>{finalName}</Title>
            <Divider />
            <IconList icons={icons} />
            <Divider />
            <Title medium>About the room</Title>
            <StyledP dangerouslySetInnerHTML={{ __html: descr }} />
            {location.ref !== 'tccw' && <StyledP>{about}</StyledP>}
            {location.ref !== 'tccw' && (
              <StyledP>
                {`Our ${`${finalName}`.toLowerCase()} rooms start from £${basePrice} per week.`}
              </StyledP>
            )}
            {floorPlan && <StyledImage src={floorPlan} />}
            <Title medium>What&apos;s Included</Title>
            <IconList icons={location.icons || []} />
            <Title medium>About The {location ? location.name : 'N/A'} Collective</Title>
            <StyledP dangerouslySetInnerHTML={{ __html: location.about }} />
            {location.video && (
              <iframe
                title="Booking Tour"
                width="100%"
                height="315px"
                src={location.video}
                allow="autoplay; encrypted-media"
              />
            )}
            <Title medium>About Co-living</Title>
            <StyledP>
              The Collective has developed a new way of living in cities that focuses on community
              and convenience. Our members have their own private rooms whilst also sharing
              beautiful spaces and having access to thought-provoking events, all designed to bring
              people together.
            </StyledP>
            <StyledP>
              Everything you need to make the most of city life is included in one convenient
              payment: rent, concierge, superfast internet, all utilities and taxes, room cleaning,
              daily events and gym membership.
            </StyledP>
            <StyledP>
              Don’t just take our word for it, though, come and see it for yourself.
            </StyledP>
          </RoomDescription>
        </RoomBody>
        {hasExpired && (
          <ExpiredContainer>
            <Expired headerImage={images.length > 0 ? images[0] : ''} />
          </ExpiredContainer>
        )}
      </StyledRoomDetail>
    )
  }
}

export const mapStateToProps = (state: State, ownProps: OwnProps) => {
  const {
    match: {
      params: { locationId, roomId }
    }
  } = ownProps
  const {
    router: {
      location: { pathname }
    },
    locations: { availableLocations },
    encryption: {
      decrypted: { createdAt }
    }
  } = state
  const hasExpired = hasDateExpired(createdAt)
  const loc =
    availableLocations && availableLocations.length > 0
      ? availableLocations.find(a => a.ref === locationId) || {}
      : {}
  return {
    pathname,
    hasExpired,
    location: loc,
    room: loc && loc.roomTypes ? loc.roomTypes.find(r => r.ref === roomId) || {} : {}
  }
}

export default connect(mapStateToProps, null)(RoomDetail)



// WEBPACK FOOTER //
// ./src/components/RoomDetail/index.js